import React from "react";
import { ScreenContentWrapper } from "../shared/ScreenContentWrapper";
import DataInterfaceHeader from "./DataInterfaceHeader";
import { DeceasedInfo } from "./DeceasedInfo";
import { EstateInfo } from "./EstateInfo";
import { ExecutorInfo } from "./ExecutorInfo";
import { BeneficiariesInfo } from "./BeneficiariesInfo";

interface IProps {
  header?: JSX.Element,
  wrapContent?: boolean,
}

export const DataInterfaceScreen = ({ header, wrapContent }: IProps): JSX.Element => {

  const withWrapper = (child: JSX.Element): JSX.Element => {
    if (wrapContent) {
      return <ScreenContentWrapper pageSuffix="File cabinet" hideImage={true}>
        {child}
      </ScreenContentWrapper>
    }

    return child
  }

  return (
    <>
      {header || <DataInterfaceHeader
        title="Estate Profile"
      />}
      {withWrapper(<div style={{ paddingBottom: "10rem" }}>
        <EstateInfo />
        <hr style={{ borderColor: "#0000001F" }} />
        <div style={{ marginTop: "2rem" }}>
          <DeceasedInfo />
          <hr style={{ borderColor: "#0000001F" }} />
        </div>
        <div style={{ marginTop: "2rem" }}>
          <ExecutorInfo />
        </div>
        <div style={{ marginTop: "2rem" }}>
          <BeneficiariesInfo />
        </div>
      </div>)}
    </>
  );
};
